export default __webpack_public_path__ + "static/project-slide-5-415-700-f4e4550a19b4de1545c7ffdb24635a9a.jpg";